import React, { useEffect } from "react";
import { Spinner, Text } from "@fluentui/react-components";
import { useStyles } from "./loadingScreenStyles";
import { appInsightsEvents, trackEvent, useAppStore } from "../../../common";

export const LoadingScreen = () => {
  const styles = useStyles();
  const context = useAppStore((state) => state.context);
  const appInsights = useAppStore((state) => state.appInsights);
  useEffect(() => {
    trackEvent(appInsights, appInsightsEvents.Usage.ViewComponent, context, {
      componentName: "LoadingScreen",
    });
  }, [appInsights, context]);

  return (
    <div className={styles.container} data-testid="loadingScreen">
      <Spinner />
      <Text className={styles.loading}>Loading...</Text>
    </div>
  );
};
